import React from 'react';
import styled from 'styled-components';

const LogoIconContainer = styled.span`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LogoIcon = () => {
  return (
    <LogoIconContainer>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 128 128"
        width="100%"
        height="100%"
        preserveAspectRatio="xMidYMid meet"
      >
        <image
          href="/icon.png"
          x="0"
          y="0"
          width="128"
          height="128"
        />
      </svg>
    </LogoIconContainer>
  );
};

export default LogoIcon;